import { render, staticRenderFns } from "./SalesSettlement.vue?vue&type=template&id=5cdba9da&scoped=true&"
import script from "./SalesSettlement.vue?vue&type=script&lang=js&"
export * from "./SalesSettlement.vue?vue&type=script&lang=js&"
import style0 from "./SalesSettlement.vue?vue&type=style&index=0&id=5cdba9da&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cdba9da",
  null
  
)

export default component.exports